/* eslint-disable import/no-unused-modules */

export const VALIDATION_RULES = {
  minLength: min => ({
    condition: value => value?.length > 0 && value?.length < min,
    message: `Please enter at least ${min} characters`
  })
};
